import { useHomeRedirect } from './hooks/useHomeRedirect';
import LoadingSpinner from './components/LoadingSpinner';

const Home = () => {
  useHomeRedirect();
  return <LoadingSpinner />;
};

export default Home;
